<div fxLayout="row" fxLayoutGap="2rem">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'tourDetails.contact' | translate }}</mat-label>
    <input matInput placeholder="{{ 'tourDetails.contact' | translate }}" [formControl]="formGroup.get('contact')">
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'core.costCenter' | translate }}</mat-label>
    <input matInput readonly disabled placeholder="{{ 'core.costCenter' | translate }}"
      value="{{ (constructionSite$ | async)?.costcenter }}"
      >
  </mat-form-field>
</div>
<div fxLayout="row">
  <mat-form-field class="content-caseNumber" appearance="outline">
    <mat-label>{{ 'tourDetails.caseNumber' | translate }}</mat-label>
    <input class="caseNumber" matInput readonly disabled placeholder="{{ 'tourDetails.caseNumber' | translate }}"
      value="{{ (constructionSite$ | async)?.transactionId }}"
      >
  </mat-form-field>
  <mat-form-field class="content-time" fxFlex="10%" appearance="outline">
    <mat-label>{{ 'core.time' | translate }}</mat-label>
    <input matInput type="time" [formControl]="formGroup.get('appointment.startTime')">
  </mat-form-field>
  <mat-form-field fxFlex="16%">
    <mat-label>{{ 'core.appointmentClass' | translate }}</mat-label>
    <mat-select
      placeholder="{{ 'core.appointmentClass' | translate }}"
      [formControl]="formGroup.get('appointment.class')">
      <mat-option [value]="null"></mat-option>
      @for (tourAppointmentClass of tourAppointmentClasses$ | async; track tourAppointmentClass) {
        <mat-option
          [value]="tourAppointmentClass.id">
          {{tourAppointmentClass.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div fxLayout="row" fxLayoutGap="2rem">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'tourDetails.supervisor' | translate }}</mat-label>
    <input matInput placeholder="{{ 'tourDetails.supervisor' | translate }}" [formControl]="formGroup.get('supervisor')">
  </mat-form-field>

  @if (tour.createdAt) {
    <mat-form-field>
      <mat-label>{{ 'tourDetails.tourCreationDate' | translate }}</mat-label>
      <input matInput disabled readonly [value]="tour.createdAt | date: 'dd.MM.yyyy HH:mm'"/>
    </mat-form-field>
  }
</div>

<div fxLayout="row" fxLayoutGap="2rem">
  <app-user-search [control]="formGroup.get('manager')"></app-user-search>
  @if (!!(constructionSite$ | async)?.uuid) {
    <div fxLayout="row" fxLayoutAlign="end start">
      <a mat-raised-button class="elo-link" color="primary"  target="_self"  [href]="('elodms://' + (constructionSite$ | async)?.uuid) | trustLink">
        <mat-icon>link</mat-icon>
        {{ 'tourDetails.eloLink' | translate }}
      </a>
    </div>
  }
</div>
